<template>
  <div class="pt-5">
    <v-data-table
      :items="clientes"
      v-model="selected"
      :server-items-length="total"
      :headers="headersList"
      :single-select="singleSelect"
      :loading="loading"
      show-select
      no-data-text="Sin clientes para mostrar"
      no-results-text="Sin resultados para mostrar"
      loading-text="Cargando..."
      :footer-props="{
        'items-per-page-options': [10, 20, 30, 40, 50],
        'items-per-page-all-text': 'Todos',
        'items-per-page-text': 'Elementos por página',
      }"
      @update:page="page = $event"
      @update:items-per-page="size = $event"
    >
      <template v-slot:top>
        <v-row style="padding: 15px;">
          <v-col cols="12" md="8">
            <h2>Clientes encontrados</h2>
          </v-col>
        </v-row>
      </template>
      <template #item.nombre_completo="{ item }">
        <span>{{
          `${item.nombre || ""} ${item.apellidoPaterno ||
            ""} ${item.apellidoMaterno || ""}`
        }}</span>
      </template>
      <template #item.ver="{ item }">
        <v-btn icon x-small @click="VerCliente(item.uuid)">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="12"
        xl="12"
        style="text-align: end; padding-top: 40px;"
      >
        <v-btn
          rounded
          dark
          class="common-botton"
          @click="dialog = true"
          :disabled="oneIsSelected"
        >
          <span>
            Confirmar seleccion
          </span>
        </v-btn>
      </v-col>
    </v-row>
    <CommonActionModal
      :dialog="dialog"
      :title="'Quieres confirmar el cliente seleccionado'"
      :subtitle="
        'Se completara los datos de la solicitud con la informacion del cliente'
      "
      :bottonText="'Si'"
      @userChoice="userChoice"
    />
  </div>
</template>

<script>
import { headersList } from "./tableClientes.js";
import CommonActionModal from "@/components/commonComponents/CommonActionModal.vue";

export default {
  props: {
    clientes: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CommonActionModal,
  },
  data() {
    return {
      headersList: headersList,
      columnsReport: [],
      singleSelect: true,
      selected: [],
      page: 0,
      size: 10,
      dialog: false,
    };
  },

  methods: {
    VerCliente(id) {
      window.open(`/detalles-cliente/${id}`);
    },
    userChoice(e) {
      this.dialog = false;
      if (e) this.$emit("postClienteSelecciondo", this.selected);
      this.selected = [];
    },
    getClientes() {
      this.$emit("getClientesPagination", { page: this.page, size: this.size });
    },
  },
  computed: {
    oneIsSelected() {
      return this.selected.length === 0;
    },
  },
  watch: {
    page(v) {
      if (v) this.pagina = v;
      this.getClientes();
    },
    size(v) {
      if (v > 0) this.size = v;
      else this.size = this.total;
      this.getClientes();
    },
  },
};
</script>

<style scoped>
.theme--light.v-data-table {
  background-color: #f2fafc;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 20px;
}
</style>
